'use cient';
import React, { FC, useEffect, useState } from 'react';
import { Select, SelectProps, Tag } from 'antd';

type Props = {
  options?: any[];
  onChange?: (value?: string[] | string) => void;
  allowClear?: boolean;
  placeholder?: string;
} & SelectProps;
const TagSelect: FC<Props> = (props) => {
  const [options, setOptions] = useState<any[]>([]);
  useEffect(() => {
    setOptions(props.options as any);
  }, [props]);

  return (
    <Select
      {...props}
      style={{ width: '100%' }}
      placeholder={props.placeholder}
      options={options.map((option) => ({
        value: option.value,
        label: (
          <span>
            <Tag color={option.color} style={{ marginRight: 8 }}>
              {option.name}
            </Tag>
          </span>
        ),
      }))}
      onChange={props.onChange}
      allowClear={props.allowClear}
    />
  );
};
export default TagSelect;
